import { Paper, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { actions } from 'redux/actions';
import Confirm from './confirm-dialog';
import { useNotification } from './hooks/notifications';
import Strap from './strap';

export default ({
  children,
  route,
  title,
  strapIcon = '',
  strapTitle = '',
  strapSubTitle = '',
  onDelete,
  editForm,
  editAction,
  onEditClick,
  isEditButton = true,
  isDeleteButton = true,
  isStrap = true,
  className = '',
}) => {
  const [isDelete, toggleDelete] = useState(false);
  const [isEdit, toggleEdit] = useState(false);

  const pendingActions = Array.isArray(editAction) ? editAction : [editAction];
  const [, successes = []] = useNotification({ actions: pendingActions });

  if (successes.length && isEdit) {
    toggleEdit(false);
  }

  const confirmDeleteHandler = (e) => {
    if (e) {
      onDelete();
    }

    toggleDelete(false);
  };

  useEffect(() => {
    const { key = '', title: _title = '', breadcrumb } = route || {};
    const [parentRoute] = breadcrumb ? breadcrumb() : [];

    actions.common.setLayoutTitle({
      layout: { title: title || _title, menu: parentRoute ? parentRoute?.route?.key : key },
    });
  }, [route, title]);

  return (
    <div className={`screen-common m-10 ${className}`}>
      {isStrap && (
        <Strap
          icon={strapIcon}
          title={strapTitle}
          subTitle={strapSubTitle}
          deleteAction={isDeleteButton ? () => toggleDelete(true) : null}
          editAction={isEditButton ? () => (onEditClick ? onEditClick() : toggleEdit(!isEdit)) : null}
        />
      )}

      {isEdit && !!editForm && (
        <Paper>
          <Typography variant="h5" component="h2" style={{ margin: '0 15px', paddingTop: 10 }}>Edit Form</Typography>
          {editForm}
        </Paper>
      )}
      {children}
      <Confirm show={isDelete} onClose={confirmDeleteHandler} isPassword />
    </div>
  );
};
